<script setup>
import { defineAsyncComponent, ref } from "vue";
import ErrorComponent from "@/Components/Custom/ErrorComponent.vue";
import Shimmer from "@/Components/Custom/Shimmer.vue";

const props = defineProps({
    path: String,
    attrs: {
        type: Object,
        default: null,
    },
});

const MODULES = import.meta.glob("./**/*.vue");
const asyncRef = ref()

const AsyncComponent = defineAsyncComponent({
    loader: () => MODULES[`./${props.path}.vue`](),
    delay: 200,
    timeout: 3000,
    errorComponent: ErrorComponent,
    loadingComponent: Shimmer,
});

defineExpose({
    asyncRef
})
</script>

<template>
    <AsyncComponent v-bind="attrs" ref="asyncRef" />
</template>
